<template>
  <div class="job-box" :class="{record:isRecord}" @click="handleDetail">
    <div class="name">
      <div class="tit">
        {{ jobInfo.title }}
      </div>
      <div v-if="info.salary_high" class="price">
        <span class="number">{{ info.salary_high }}</span>
        <span class="unit">{{ info.salary_unit | unitFormat }}</span>
      </div>
      <div v-else class="price">
        <span class="salary-face">面议</span>
      </div>
    </div>
    <div class="info">
      <div class="detail-box">
        <div v-if="isRecord" class="record-info">
          <div class="job-tag">
            <div v-if="info.regionInfo" class="tag-item">
              {{ info.regionInfo }}
            </div>
            <div v-if="info.salaryModel" class="tag-item">
              {{ info.salaryModel }}
            </div>
            <div v-if="info.peoples" class="tag-item">
              {{ info.peoples }}人
            </div>
          </div>
          <!-- <div class="date-box">
            <span>{{ info.created_at | dateFilter }}</span>
          </div> -->
        </div>
        <div v-else class="job-tag">
          <div v-if="regionDisplay" class="tag-item">
            {{ regionDisplay }}
          </div>
          <div v-if="info.salaryModel" class="tag-item active">
            {{ info.salaryModel }}
          </div>
          <div v-if="info.peoples" class="tag-item active">
            {{ info.peoples }}人
          </div>
        </div>
        <template v-if="type!=='record'">
          <div v-if="type==='nearby'" class="distance">
            {{ info.distance | distance }}
          </div>
          <div v-else class="distance">
            {{ (info.info_updated_at||info.updated_at) | dateFilter }}
          </div>
        </template>
      </div>

      <!-- <div v-if="!isRecord" class="contact-box">
        <div class="contact-btn">
          极速联系
        </div>
      </div> -->
    </div>
    <div v-if="isRecord" class="record-company">
      <div class="record-company_name">{{ info.companyName }}</div>
      <div class="record-company_date">
        <template v-if="isLog">
          {{ ( info.call_time || info.view_time ) | timeFilter }}
        </template>
        <template v-else>
          {{ info.created_at | dateFilter }}
        </template>
      </div>
    </div>
    <div v-else class="company">
      <img v-if="info.company && info.company.logo" :src="info.company.logo.url?info.company.logo.url+'?x-oss-process=image/resize,m_lfit,h_240,w_240':info.company.logo+'?x-oss-process=image/resize,m_lfit,h_240,w_240'" class="company-avatar" alt="">
      <img v-else class="company-avatar" src="../assets/image/default_company_logo.png" alt="">
      <div class="company-name">
        {{ info.type===2 ? info.company.name || info.company_name: info.user.name }}
        <base-icon v-if="info.type === 2" name="icon_company" class="icon" />
        <base-icon v-if="info.type === 1" name="icon_person" class="icon" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex';
export default {
  name: '',
  filters: {
    distance(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      if (value < 1000) {
        return `${value}m`;
      } else {
        return `${(value / 1000).toFixed(1)}km`;
      }
    },
  },
  components: {},
  props: {
    info: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: '',
    },
    isLog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['dict']),
    isRecord() {
      return Boolean(this.type === 'record')
    },
    jobInfo() {
      return this.info
    },
    regionDisplay() {
      const regionInfo = this.jobInfo.regionInfo;
      if (!regionInfo) {
        return '地点不限';
      }
      return regionInfo ? regionInfo.name : '地点不限';
    },
    businessCircle() {
      return (this.jobInfo.trading_area && this.jobInfo.trading_area.name) || '';
    },
    tradingDisplay() {
      return (this.jobInfo.trading_area && this.jobInfo.trading_area[0] && this.jobInfo.trading_area[0].name) || '';
    },
    workExpDisplay() {
      return this.jobInfo.work_years === 0 ? '经验不限' : this.jobInfo.work_years_value;
    },
    eduDisplay() {
      return this.jobInfo.edu === 0 ? '学历不限' : this.jobInfo.edu_value;
    },
  },
  methods: {
    handleDetail() {
      if (this.type === 'record') {
        this.$router.push({ name: 'job-id', params: { id: this.jobInfo.info_id } });
      } else {
        this.$router.push({ name: 'job-id', params: { id: this.jobInfo.id } });
      }
    },
  },
}

</script>
<style lang='less' scoped>
.job-box {
  border-radius: 16px;
  background: #ffffff;
  padding: 30px 30px 0 30px;
  margin-bottom: 16px;
  &.record {
    border-top: 1px solid #dcdfe6b2;
    border-radius: 0;
    padding: 20px 30px 0 30px;
  }
  .name {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 34px;
      font-weight: 500;
      color: #262626;
    }
    .price {
      flex-shrink: 0;
      margin: 16px 0;
      color: #e84c3d;
      font-weight: 600;
      .number {
        font-size: 36px;
      }
      .unit {
        position: relative;
        top: -2px;
        font-size: 24px;
        margin-left: 6px;
      }
      .salary-face {
        font-size: 30px;
      }
    }
  }
  .info {
    display: flex;
    .detail-box {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .job-tag {
        position: relative;
        left: -2px;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        flex-wrap: nowrap;
        .tag-item {
          padding: 9px 11px;
          background: #f6f7f8;
          border-radius: 8px;
          font-size: 20px;
          color: #666666;
          margin-bottom: 10px;
          max-width: 400px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &.active {
            background: #fef3e3;
            color: #ff6000;
          }
          & + .tag-item {
            margin-left: 10px;
          }
        }
      }
      .distance {
        color: #b3b3b3;
        font-size: 24px;
        flex-shrink: 0;
        margin-left: 10px;
      }
      .record-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .date-box {
          flex-shrink: 0;
        }
      }
    }
    .date-box {
      color: #999999;
      font-size: 24px;
    }
    .contact-btn {
      background: linear-gradient(135deg, #ff8a3f 0%, #fd5c60 100%);
      border-radius: 60px;
      padding: 13px 18px;
      color: #ffffff;
      font-weight: 500;
      font-size: 22px;
    }
  }
  .company {
    border-top: 1px solid #f1f2f6;
    display: flex;
    padding: 16px 0;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
    .company-avatar {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #e6e6e6;
    }
    .company-name {
      flex: 1;
      margin-left: 12px;
      color: #666666;
      font-size: 24px;
      .icon {
        width: 32px;
        height: 32px;
        margin-left: 2px;
      }
    }
  }
  .record-company {
    display: flex;
    justify-content: space-between;
    float: 1;
    padding: 10px 0 10px 0;
    &_name {
      color: #666666;
      font-size: 24px;
    }
    &_date {
      color: #b3b3b3;
      font-size: 24px;
    }
  }
}
</style>